<template>
  <loan-status-alert-container :loan="loan">
    <template #borrower>
      {{ $t("components.loan.status.alerts.canceled.borrower") }}
    </template>

    <template #owner>
      {{ $t("components.loan.status.alerts.canceled.owner", { name: loan.borrower_user.name }) }}
    </template>

    <template #admin>
      {{ $t("components.loan.status.alerts.canceled.admin") }}
    </template>
  </loan-status-alert-container>
</template>

<script>
import LoanStatusAlertContainer from "@/components/Loan/Status/Alerts/LoanStatusAlertContainer.vue";

export default {
  name: "LoanCanceled",
  components: {
    LoanStatusAlertContainer,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss"></style>
